export default {
  vanilla: require('./vanilla/generate').default
};
